export const LOCALIZATION_OPTIONS = [
  {
    label: 'English',
    value: 'en',
    flag: 'gb',
  },
  {
    label: 'Chinese (Simplified) / 简体中文',
    value: 'zh',
    flag: 'cn',
  },
];

export const NUMBER_REGEX =
  /^(?:-(?:[1-9](?:\d{0,2}(?:,\d{3})+|\d*))|(?:0|(?:[1-9](?:\d{0,2}(?:,\d{3})+|\d*))))(?:.\d+|)$/;
